export default __webpack_public_path__ + "static/media/athletics.58015587.jpeg";